module.exports = __webpack_public_path__ + "static/media/zf_2.63782e4c.png";